var map = {
	"./crown.svg": 7225,
	"./games/Conv3D.png": 19193,
	"./games/CouAvantArriere.jpg": 54055,
	"./games/CouDiagonal.jpg": 99661,
	"./games/CouHorizontal.jpg": 94312,
	"./games/DemiCercle.jpg": 59307,
	"./games/Div3D.jpg": 22352,
	"./games/DosEtirements.jpg": 50958,
	"./games/DosJambesEtirements.jpg": 66731,
	"./games/EpaulesEtirementsHautBas.jpg": 56867,
	"./games/Horloge.jpg": 37285,
	"./games/Infini.jpg": 94516,
	"./games/LaCroix.jpg": 47815,
	"./games/LeCrayon.png": 61797,
	"./games/LeDemiCercleDroite.png": 79503,
	"./games/LeV.png": 789,
	"./games/LeX.png": 72298,
	"./games/Lecrayon.jpg": 65432,
	"./games/LoinPres.jpg": 47133,
	"./games/LoinPres.png": 79849,
	"./games/MemoryBox.png": 80527,
	"./games/Palming.jpg": 19431,
	"./games/PingPongH.jpg": 95526,
	"./games/PingPongH.png": 69572,
	"./games/PingPongV.jpg": 43749,
	"./games/PingPongV.png": 77685,
	"./games/PrevDemiCercle.jpg": 73892,
	"./games/PrevInfini.jpg": 66307,
	"./games/PrevX.jpg": 93031,
	"./games/Rapido.jpg": 19479,
	"./games/SaccadesDynamiquesHorizontales.jpg": 58710,
	"./games/blackball.jpg": 2716,
	"./games/blackball.png": 4271,
	"./games/colordrops.png": 12987,
	"./games/fishgame.png": 83793,
	"./games/flakesrace.png": 69431,
	"./games/loucher.jpg": 68930,
	"./games/memofun.jpg": 33014,
	"./games/memory.png": 63126,
	"./games/numberquiz.png": 99937,
	"./games/numbers.jpg": 11886,
	"./games/numbers.png": 65308,
	"./games/rapidobee.jpg": 19694,
	"./images3d/Q29jaG9u.jpg": 15470,
	"./images3d/Q29ldXI=.jpg": 98015,
	"./images3d/Q29sb21iZQ==.png": 37789,
	"./images3d/Q2VyZg==.png": 38762,
	"./images3d/Q2hhdA==.png": 32973,
	"./images3d/Q2hldmFs.png": 9618,
	"./images3d/QXZpb24=.png": 3547,
	"./images3d/Qm91ZGRoYQ==.jpg": 8204,
	"./images3d/R2xvYmVUZXJyZXN0cmU=.png": 19871,
	"./images3d/R3VpdGFyZQ==.png": 371,
	"./images3d/RWxlcGhhbnRz.png": 32367,
	"./images3d/RXRvaWxl.png": 45059,
	"./images3d/RmxldXI=.png": 2175,
	"./images3d/SGlwcG9jYW1wZQ==.png": 92045,
	"./images3d/TWFpbg==.jpg": 78329,
	"./images3d/UG9pc3Nvbg==.jpg": 28631,
	"./images3d/UGFwaWxsb24=.jpg": 28388,
	"./images3d/UGxhbmV0ZQ==.png": 73516,
	"./images3d/VGV0ZWRlQ2hhdA==.png": 60202,
	"./images3d/VHJhaW5Mb2NvbW90aXZl.jpg": 44601,
	"./images3d/VHJpY3ljbGU=.jpg": 81910,
	"./images3d/Vm9pdHVyZQ==.jpg": 12691,
	"./images3dthumbnails/Q29jaG9u.jpg": 43921,
	"./images3dthumbnails/Q29ldXI=.jpg": 41193,
	"./images3dthumbnails/Q29sb21iZQ==.jpg": 7816,
	"./images3dthumbnails/Q2VyZg==.jpg": 24473,
	"./images3dthumbnails/Q2hhdA==.jpg": 87433,
	"./images3dthumbnails/Q2hldmFs.jpg": 52563,
	"./images3dthumbnails/QXZpb24=.jpg": 49804,
	"./images3dthumbnails/Qm91ZGRoYQ==.jpg": 62713,
	"./images3dthumbnails/R2xvYmVUZXJyZXN0cmU=.jpg": 55961,
	"./images3dthumbnails/R3VpdGFyZQ==.jpg": 17057,
	"./images3dthumbnails/RWxlcGhhbnRz.jpg": 99799,
	"./images3dthumbnails/RXRvaWxl.jpg": 76356,
	"./images3dthumbnails/RmxldXI=.jpg": 49096,
	"./images3dthumbnails/SGlwcG9jYW1wZQ==.jpg": 46232,
	"./images3dthumbnails/TWFpbg==.jpg": 27956,
	"./images3dthumbnails/UG9pc3Nvbg==.jpg": 67852,
	"./images3dthumbnails/UGFwaWxsb24=.jpg": 55129,
	"./images3dthumbnails/UGxhbmV0ZQ==.jpg": 95806,
	"./images3dthumbnails/VGV0ZWRlQ2hhdA==.jpg": 23171,
	"./images3dthumbnails/VHJhaW5Mb2NvbW90aXZl.jpg": 78006,
	"./images3dthumbnails/VHJpY3ljbGU=.jpg": 52266,
	"./images3dthumbnails/Vm9pdHVyZQ==.jpg": 50851,
	"./onboarding/1-fr.jpg": 18581,
	"./onboarding/1-us.jpg": 55109,
	"./onboarding/2-fr.jpg": 43914,
	"./onboarding/2-us.jpg": 65688,
	"./onboarding/3-fr.jpg": 93309,
	"./onboarding/3-us.jpg": 71853,
	"./onboarding/4-fr.jpg": 21409,
	"./onboarding/4-us.jpg": 43456,
	"./onboarding/5-fr.jpg": 83921,
	"./onboarding/5-us.jpg": 46448,
	"./onboarding/6-fr.jpg": 89631,
	"./onboarding/6-us.jpg": 61174,
	"./vizy-head.png": 54386,
	"./vizygood.ico": 98507
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 50425;